import { render, staticRenderFns } from "./ProfileDetail.vue?vue&type=template&id=112f4e23"
import script from "./ProfileDetail.vue?vue&type=script&lang=js"
export * from "./ProfileDetail.vue?vue&type=script&lang=js"
import style0 from "./ProfileDetail.vue?vue&type=style&index=0&id=112f4e23&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports